// extracted by mini-css-extract-plugin
export default {"clientInfoTitle":"ClientInfoTitle_clientInfoTitle__Fctwo","fadeInUp":"ClientInfoTitle_fadeInUp__l04aF"};